<template>
	<div class="empty-content">
		<ud-empty-row :height="height" />
		<img class="empty-content-image" :src="pic" mode="widthFix" />
		<ud-empty-row height="48" />
		<!-- <text class="empty-content-text">{{ text }}</text> -->
	</div>
</template>

<script>
  import UdEmptyRow from '@/components/ud-empty-row'
	export default {
		props: {
			height: {
				type: [String, Number],
				default: 150
			},
			text: {
				type: String,
				default: '暂无信息'
			},
			pic: {
				type: String,
				default: 'https://oss-public.uopgenjoy.com/prod/static/property/images/global/img-empty-01.png'
			}
		},
    components: {
    UdEmptyRow
  },
	}
  
</script>

<style lang="scss" scoped>
	.empty-content {
		@extend .flex-column;
		align-items: center;

		&-image {
			width: 368px;
			height: 369px;
		}

		&-text {
			@include text(36rpx, 400, rgba(141, 140, 140, 1));
		}
	}
</style>
